export default __webpack_public_path__ + "static/interactive-brand-guidelines@2x-74466f230d79ab0b23105ad7bec41509.png";